import { render } from "./SearchHotLinks.vue?vue&type=template&id=03ae3abe&scoped=true"
import script from "./SearchHotLinks.vue?vue&type=script&lang=js"
export * from "./SearchHotLinks.vue?vue&type=script&lang=js"

import "./SearchHotLinks.vue?vue&type=style&index=0&id=03ae3abe&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ae3abe"]])

export default __exports__